import template from './circle-chart.html';
import controller from './circle-chart.controller';
import './circle-chart.scss';

const CircleChartComponent = {
  template,
  controller,
  bindings: {
    percent: '<'
  },
  controllerAs: 'vm'
};

export default CircleChartComponent;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/dashboard/components/circle-chart/index.js